export enum ExportStatus {
  Exporting = "Exporting",
  Finished = "Finished",
  NoData = "NoData",
}